// Auto-generated skeleton for AccountBalance

export const AccountBalance: Api.AccountBalance = {
  id: 0,
  hp_id: null,
  account_id: 0,
  review_document_id: 0,
  opening_balance: 0,
  debit: 0,
  debit_vat: 0,
  credit: 0,
  credit_vat: 0,
  account: null,
  review_document: null,
  created: null,
  updated: null,
};

